"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.JoinSecondary = void 0;
var _react = _interopRequireDefault(require("react"));
var _types = require("../../../types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var JoinSecondary = exports.JoinSecondary = function JoinSecondary(_ref) {
  var price = _ref.price,
    isMobile = _ref.isMobile,
    theme = _ref.theme,
    term = _ref.term,
    onClick = _ref.onClick;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(theme === "light" ? "text-black" : "text-white", " text-center")
  }, /*#__PURE__*/_react["default"].createElement("span", null, "Save money with ", term === _types.BoostTerm.MONTHLY ? "a monthly" : "an annual", " ", "subscription!", isMobile ? /*#__PURE__*/_react["default"].createElement("br", null) : " ", /*#__PURE__*/_react["default"].createElement("span", {
    className: "font-semibold underline cursor-pointer text-center",
    onClick: onClick
  }, "Subscribe for $", price.toFixed(2), "/mo, billed ", term)));
};